// extracted by mini-css-extract-plugin
export default {"bubbleContainer":"FullScreenBubble_bubbleContainer__oD8rb","bubble":"FullScreenBubble_bubble__26JmP"};